export default __webpack_public_path__ + "assets/models/6ed5de098bc84cf895b91679119f9a2b.glb";